<template>
    <div class="container">
        <h3>参加票</h3><br>
        <div class="input-group-container" role="group">
            <div class="add-name">
                <label for="input-live">Youtube Name:</label>
                <b-form-input
                    v-composition-model="inputYoutubeName"
                    :value="inputYoutubeName"
                    placeholder="Youtube Name"
                    class="input-name"
                    trim
                    @click="enableSuggest = true"
                    @blur="closeSuggest()"
                ></b-form-input>
                <div class="suggest" v-show="enableSuggest && filterName.length !== 0">
                    <div class="suggestHeader" :style="{backgroundColor: '#2c3e50', width: '300px'}">過去の履歴</div>
                    <div class="suggestScrollPane">
                        <div class="suggestItem" v-for="item in filterName" :key="item.id + 'hoge'" @mousedown.prevent="pushStorageItem(item), closeSuggest()">
                            <span class="suggestYoutubeName">{{ item.name }}</span>
                            <span class="suggestHunterName">{{ item.hname }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="add-name">
                <label for="input-live">Hunter Name:</label>
                <b-form-input
                v-model="inputHunterName"
                placeholder="Hunter Name"
                trim
                ></b-form-input>
            </div>
            <div class="add-name">
                <label for="input-live">MR:</label>
                <b-form-input
                v-model="mrValue"
                placeholder="MR"
                type="number"
                trim
                ></b-form-input>
            </div>
            <div class="input-add-button">
                <b-button pill variant="outline-primary" class="add-button" @click="addName">
                    追加
                </b-button>
            </div>
        </div>
            <div class="leftContent">
                最大参加人数: <input
                    class="input-edit-content-number"
                    :style="{color:'blue', border: '1px solid black'}"
                    v-model="participantsNum"
                    placeholder="MR"
                    type="number"
                    trim
                />人
            </div>
        <div>
            <div class="leftContent">
                <p>
                    ※次のクエストは<strong :style="{color: 'red'}">MR{{lowerHunterRank(participantsNum)}}</strong>以下のクエストにしましょう！
                    <span :style="{color: 'green'}">{{ enableMember.length !== 0 ? `(現在${ enableMember.length}名)`: '' }}</span>
                </p>
            </div>
        </div>
        <div v-if="enableMember.length !== 0" class="table-container">
            <table ref="joinPeople">
                <thead class="thead-dark">
                <tr>
                    <th></th>
                    <th class="queue-name-column" scope="col">Youtube名</th>
                    <th class="queue-name-column" scope="col">ハンター名</th>
                    <th class="queue-mr-column" scope="col">MR</th>
                    <th class="queue-mr-column" scope="col">参加回数</th>
                    <th class="queue-next-column" scope="col">
                        操作
                    </th>
                </tr>
                </thead>
                <draggable v-model="enableMember" tag="tbody" v-bind=options @start="dragging=true" @end="dragging=false" handle=".handle">
                    <transition-group :name="dragging ? null : 'fade'" class="transition-inner-table">
                        <tr v-for="(item, index) in enableMember" :key="item.id" class="item" :class="{ 'next-participate': index < participantsNum }">
                            <td>
                                <font-awesome-icon class="handle" icon="align-justify" />
                            </td>
                            <td v-if="!item.editYoutubeName" @click="item.editYoutubeName = true, focusElement('youtube-name-'+String(item.id))" class="queue-name-column" :class="{'no-text': item.name === ''}">
                                {{ item.name ? item.name : '未入力'}}
                            </td>
                            <td class="input-edit" v-else>
                                <div class="centeringTd">
                                    <input
                                        v-model="item.name"
                                        placeholder="Youtube Name"
                                        class="input-edit-content"
                                        :id="'youtube-name-'+String(item.id)"
                                        @blur="item.editYoutubeName = false, updateUserData(extractUserData(item))"
                                        trim
                                    />
                                </div>
                            </td>
                            <td v-if="!item.editHunterName" @click="item.editHunterName = true, focusElement('youtube-hname-'+String(item.id))" class="queue-name-column" :class="{'no-text': item.hname === ''}">
                                {{ item.hname ? item.hname : '未入力'}}
                            </td>
                            <td class="input-edit" v-else>
                                <div class="centeringTd">
                                    <input
                                        v-model="item.hname"
                                        placeholder="Hunter Name"
                                        class="input-edit-content"
                                        :id="'youtube-hname-'+String(item.id)"
                                        @blur="item.editHunterName = false, updateUserData(extractUserData(item))"
                                        trim
                                    />
                                </div>
                            </td>
                            <td v-if="!item.editMR" @click="item.editMR = true, focusElement('youtube-mr-'+String(item.id))" class="queue-mr-column" :class="{'no-text': item.mrValue === null}">
                                {{ item.mrValue ? item.mrValue : '未入力'}}
                            </td>
                            <td class="input-edit-number" v-else>
                                <div class="centeringTd">
                                    <input
                                        v-model="item.mrValue"
                                        class="input-edit-content-number"
                                        placeholder="MR"
                                        :id="'youtube-mr-'+String(item.id)"
                                        type="number"
                                        @blur="item.editMR = false, updateUserData(extractUserData(item))"
                                        trim
                                    />
                                </div>
                            </td>
                            <td v-if="!item.editJoin" @click="item.editJoin = true, focusElement('youtube-join-'+String(item.id))" class="queue-mr-column">
                                {{ item.joinCount }}
                            </td>
                            <td class="input-edit-number" v-else>
                                <div class="centeringTd">
                                    <input
                                        v-model="item.joinCount"
                                        class="input-edit-content-number"
                                        :id="'youtube-join-'+String(item.id)"
                                        type="number"
                                        @blur="item.editJoin = false, updateUserData(extractUserData(item))"
                                        trim
                                    />
                                </div>
                            </td>
                            <td class="queue-next-column">
                                <b-button pill variant="warning" class="done-button" @click="finishQueue(item.id)">
                                    次
                                </b-button>
                                <b-button pill variant="danger" class="done-button" @click="popQueue(item.id, true)">
                                    退室
                                </b-button>
                            </td>
                        </tr>
                    </transition-group>
                </draggable>
            </table>
        </div>
        <!-- {{ JSON.stringify(this.list, null, 2) }} -->
        <div v-if="disableMember.length !== 0" class="table-container">
            <h3>退室したメンバー: {{disableMember.length}}名</h3>
            <table ref="exitPeople">
                <thead class="thead-dark">
                <tr>
                    <th></th>
                    <th class="queue-name-column" scope="col">Youtube名</th>
                    <th class="queue-name-column" scope="col">ハンター名</th>
                    <th class="queue-mr-column" scope="col">MR</th>
                    <th class="queue-mr-column" scope="col">参加回数</th>
                    <th class="queue-next-column" scope="col">
                    </th>
                </tr>
                </thead>
                <draggable v-model="disableMember" tag="tbody" v-bind=options is="transition-group" name="fade" handle=".handle">
                    <tr v-for="item in disableMember" :key="item.id" class="disabled-item">
                        <td><font-awesome-icon class="handle" icon="align-justify" /></td>
                        <td v-if="!item.editYoutubeName" @click="item.editYoutubeName = true, focusElement('youtube-name-'+String(item.id))" class="queue-name-column" :class="{'no-text': item.name === ''}">
                            {{ item.name ? item.name : '未入力'}}
                        </td>
                        <td class="input-edit" v-else>
                            <div class="centeringTd">
                                <input
                                    v-model="item.name"
                                    placeholder="Youtube Name"
                                    class="input-edit-content"
                                    :id="'youtube-name-'+String(item.id)"
                                    @blur="item.editYoutubeName = false, updateUserData(extractUserData(item))"
                                    trim
                                />
                            </div>
                        </td>
                        <td v-if="!item.editHunterName" @click="item.editHunterName = true, focusElement('youtube-hname-'+String(item.id))" class="queue-name-column" :class="{'no-text': item.hname === ''}">
                            {{ item.hname ? item.hname : '未入力'}}
                        </td>
                        <td class="input-edit" v-else>
                            <div class="centeringTd">
                                <input
                                    v-model="item.hname"
                                    placeholder="Hunter Name"
                                    class="input-edit-content"
                                    :id="'youtube-hname-'+String(item.id)"
                                    @blur="item.editHunterName = false, updateUserData(extractUserData(item))"
                                    trim
                                />
                            </div>
                        </td>
                        <td v-if="!item.editMR" @click="item.editMR = true, focusElement('youtube-mr-'+String(item.id))" class="queue-mr-column" :class="{'no-text': item.mrValue === null}">
                            {{ item.mrValue ? item.mrValue : '未入力'}}
                        </td>
                        <td class="input-edit-number" v-else>
                            <div class="centeringTd">
                                <input
                                    v-model="item.mrValue"
                                    class="input-edit-content-number"
                                    placeholder="MR"
                                    :id="'youtube-mr-'+String(item.id)"
                                    type="number"
                                    @blur="item.editMR = false, updateUserData(extractUserData(item))"
                                    trim
                                />
                            </div>
                        </td>
                        <td class="queue-mr-column">
                            {{ item.joinCount }}
                        </td>
                        <td class="queue-next-column">
                            <b-button pill variant="success" class="done-button" @click="popQueue(item.id, false)">
                                入室
                            </b-button>
                        </td>
                    </tr>
                </draggable>
            </table>
        </div>
        <footer>
            Created by MF. Twitter@kusoengifuck
        </footer>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import Vue from 'vue';
function vCompositionModelUpdate (el, { expression }, vnode) {
    // data書き換え
    vnode.context[expression] = el.value
}
Vue.directive('composition-model', {
    bind: function (el, binding, vnode) {
        el.value = binding.value;
        el.addEventListener('keyup', () => vCompositionModelUpdate(el, binding, vnode));
        el.addEventListener('compositionend', () => vCompositionModelUpdate(el, binding, vnode));
    },
})
export default {
    name: "table-example",
    display: "Table",
    order: 8,
    components: {
        draggable
    },
    data() {
        return {
            enableMember: [],
            disableMember: [],
            dragging: false,
            options: {
                animation: 200,
            },
            inputYoutubeName: '',
            inputHunterName: '',
            mrValue: null,
            participantsNum: 4,
            loadedLocalStorage: null,
            enableSuggest: false,
        };
    },
    mounted() {
        if(localStorage.getItem('users')) {
            this.parseLocalStorageUserData();
        }
    },
    methods: {
        parseLocalStorageUserData: function() {
            try {
                return this.loadedLocalStorage = JSON.parse(localStorage.getItem('users'));
            } catch(e) {
                alert('読み込みに失敗しました。LocalStorage can not load.')
            }
        },
        finishQueue: function(id) {
            const index = this.enableMember.findIndex(el => el.id === id);
            const obj = this.enableMember[index];
            this.$set(obj, 'joinCount', obj.joinCount+1);
            this.enableMember.splice(index, 1);
            this.enableMember.push(obj);
        },
        popQueue: function(id, status) {
            if(status){
                const index = this.enableMember.findIndex(el => el.id === id);
                const obj = this.enableMember[index];
                this.enableMember.splice(index, 1);
                this.disableMember.push(obj);
            }else {
                const index = this.disableMember.findIndex(el => el.id === id);
                const obj = this.disableMember[index];
                this.disableMember.splice(index, 1);
                this.enableMember.push(obj);
            }
        },
        makeId: function() {
            return Math.random().toString(32).substring(2);
        },
        addName: function() {
            if(!this.nameState) {
                alert('名前を入力してね');
                return;
            }
            const yname = this.inputYoutubeName;
            const hname = this.inputHunterName;
            const uid = this.makeId();
            const mrValue = this.mrValue;
            const user = {
                id: uid,
                name: yname,
                hname: hname,
                mrValue: mrValue
            }
            this.enableMember.push({
                ...user,
                editYoutubeName: false,
                editHunterName: false,
                editMR: false,
                editJoin: false,
                joinCount: 0,
            });
            this.updateUserData(user);
            this.inputYoutubeName = '';
            this.inputHunterName = '';
            this.mrValue = null;
        },
        extractUserData: function(data) {
            const {
                id,
                name,
                hname,
                mrValue,
            } = data
            return {
                id, name, hname, mrValue,
            }
        },
        focusElement: function(idname) {
            this.$nextTick(() => document.getElementById(idname).focus());
        },
        lowerHunterRank(memberCount) {
            let ret = 999;
            for(var i = 0; i < this.enableMember.length; i++){
                if(i >= memberCount) break;
                if(this.enableMember[i].mrValue){
                    ret = Math.min(ret, this.enableMember[i].mrValue);
                }
            }
            return ret;
        },
        updateUserData: function(user) {
            if ( !this.loadedLocalStorage ) {
                this.saveNewUsers([user])
                return;
            } else {
                const storage = this.parseLocalStorageUserData()
                // eslint-disable-next-line no-console
                // console.log(storage)
                const index = storage.findIndex(el => el.id === user.id);
                if(index !== -1) {
                    storage.splice(index, 1);
                }
                this.saveNewUsers([...storage, user])
            }
        },
        saveNewUsers: function (users) {
            const parsed = JSON.stringify(users);
            localStorage.setItem('users', parsed);
            this.loadedLocalStorage = users;
        },
        pushStorageItem: function (item) {
            this.enableMember.push({
                id: item.id,
                name: item.name,
                hname: item.hname,
                mrValue: item.mrValue,
                editYoutubeName: false,
                editHunterName: false,
                editMR: false,
                editJoin: false,
                joinCount: 0,
            });
            this.inputHunterName = '';
            this.inputYoutubeName = '';
            this.mrValue = null;
        },
        closeSuggest: function() {
            this.enableSuggest = false
            // this.$nextTick(() => this.enableSuggest = false);
        },
    },
    computed: {
        nameState() {
            return this.inputYoutubeName === '' ? null : true;
        },
        filterName: function() {
            const key = this.inputYoutubeName.toLowerCase();
            var members = this.loadedLocalStorage;
            if(!members) return [];
            const self = this
            members = members.filter(el => {
                return ([...self.enableMember, ...self.disableMember].findIndex(el2 => el2.id === el.id) === -1);
            })
            if(key !== '') {
                members = members.filter(el => {
                    const name = String(el.name).toLowerCase();
                    const hname = String(el.hname).toLowerCase();
                    const key1 = name.indexOf(key);
                    const key2 = hname.indexOf(key);
                    return (key1 > -1) || (key2 > -1);
                })
            }
            return members;
        },
    },
};
</script>
<style lang="scss" scoped>
.table-container {
    margin-bottom: 20px;
}

.add-name {
    display: inline-block;
    align-items: baseline;
    padding: 10px;
}

.done-button {
    min-width: 66px;
    padding: 5px 20px;
    font-size: .8rem;
    font-weight: bold;
    margin: 0 5px;
}
.add-button {
    padding: 5px 20px;
    font-size: 1rem;
}

.item {
    border: 1px solid #7f7f7f;
    border-radius: 10px;
    background-color: #ffffff;
}

.disabled-done-button {
    background-color: #c04a4a;
    color: white;
}

.disabled-item {
    background-color: #c04a4a;
    border: 1px solid #444444;
    border-radius: 10px;
    color: white;
}

.input-add-button{
    display: inline-block;
    vertical-align: bottom;
    margin-bottom: 10px;
    padding-left: 10px;
}

table {
    /* text-align: left; */
    // max-width: 550px;
    // width: 100vw;
    border: 3px solid #2c3e50;
    font-weight: bold;
    border-radius: 20px;
}
.container {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    width: 100vw;
    text-align: center;
    color: #2c3e50;
    margin-top: 40px;
    height: 100vh;
}

.buttons {
    margin-top: 35px;
}

.fade-leave-active,
.fade-enter-active {
    transition: opacity .4s, transform .4s ease-in;
}
.fade-leave-to,
.fade-enter {
    opacity: 0;
    transform: translateX(50px);
}
.fade-leave,
.fade-enter-to {
    opacity: 1;
}
.fade-move {
    transition: transform .5s ease;
}

.next-participate {
    background-color: #7fffd4;
}

.transition-inner-table {
    display: contents;
}

.ghost {
}

footer {
    margin-top: auto;
    padding: 50px;
}

.input-name {
    max-width: 193px;
    min-width: 150px;
}

.no-text {
    color: rgb(172, 172, 172);
}

.queue-mr-column {
    max-width: 80px;
    width: 80px;
    overflow: hidden;
    vertical-align: middle;
}

.handle {
    width: 30px;
    height: 30px;
}

.handle:hover {
    cursor: grab;
}
.handle:active {
    cursor: grabbing;
}


.queue-id-column {
    max-width: 200px;
    width: 200px;
    overflow: hidden;
}
.queue-name-column {
    max-width: 130px;
    width: 130px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    vertical-align: middle;
    padding: 0 5px;
    margin: 0;
}
.queue-detail-column {
}

.queue-next-column {
    max-width: 200px;
    width: 200px;
    overflow: hidden;
    vertical-align: middle;
}


.input-edit-content {
    border: none;
    background-color: transparent;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    color: #2c3e50;
    max-width: 130px;
    width: 130px;
}

.input-edit {
    max-width: 130px;
    width: 130px;
    padding: 0px;
    overflow: hidden;
    color: #2c3e50;
}

.input-edit-number {
    max-width: 80px;
    width: 80px;
    padding: 0px;
    overflow: hidden;
    color: #2c3e50;
}

.input-edit-content-number {
    max-width: 80px;
    width: 80px;
    border: none;
    background-color: transparent;
    font-weight: bold;
    text-align: center;
    outline: none;
    color: #2c3e50;
}

.thead-dark {
    background-color: rgb(53, 58, 64);
    color: white;
}

td {
    vertical-align: middle;
    // border: 1px solid #2c3e50;
    padding: 2px;
}

th {
    width: 40px;
}

.centeringTd {
}

.leftContent {
    float: left;
    padding: 4px;
}

input[list]{
    margin-left:auto;
    margin-right:auto;
    max-width: 500px;
    padding: 20px 20px 20px 20px;
    font: 12px Arial, Helvetica, sans-serif;
}

.suggest {
    display: block;
    position: absolute;
    background-color: #ffffff;
    border: 1px solid #2c3e50;
    border-radius: 0 0 4px 4px;
    text-align: left;
    width: 300px;
    color: white;
    z-index: 100;
    max-height: 200px;
    overflow: hidden;
}

.suggestItem {
    padding: 5px;
    border-bottom: 1px solid #2c3e50;
    &:hover {
        background-color: #e3e3e3;
    }
}

.suggestYoutubeName {
    color:#2c3e50;
    font-weight: bold;
}

.suggestHunterName {
    color: gray;
    font-size: 0.8rem;
    margin-left: 5px;
}

.suggestScrollPane {
    max-height: 130px;
    overflow-y: scroll;
}

.suggestHeader {
    border-bottom: 1px solid #2c3e50;
    padding-left: 5px;
}


</style>